export default "__VITE_ASSET__DDJ6_CoV__"